/**
 * ConnectButton — wraps Reown AppKit's programmatic modal with a styled
 * button. On disconnected state it opens the wallet picker; when
 * connected it shows the short address and clicking disconnects.
 */

import { useAppKit } from "@reown/appkit/react";
import { useAccount, useDisconnect } from "wagmi";
import { shortAddress } from "@/lib/format";

export function ConnectButton() {
  const { open } = useAppKit();
  const { address, isConnected, isConnecting } = useAccount();
  const { disconnect } = useDisconnect();

  if (isConnected && address) {
    return (
      <button
        type="button"
        onClick={() => disconnect()}
        className="inline-flex items-center gap-2 rounded-full border border-[--border] bg-[--bg-elev] px-3.5 py-1.5 text-sm font-medium text-[--text] hover:border-[--border-strong] transition"
      >
        <span className="size-2 rounded-full bg-[--success]" />
        <span className="num">{shortAddress(address)}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => open({ view: "Connect" })}
      disabled={isConnecting}
      className="inline-flex items-center gap-2 rounded-full bg-[--accent] px-4 py-1.5 text-sm font-semibold text-[--accent-on] shadow-sm hover:bg-[--accent-hover] disabled:opacity-60 transition"
    >
      {isConnecting ? "Connecting…" : "Connect wallet"}
    </button>
  );
}
